module.exports = __webpack_public_path__ + "static/media/chinese.msyh.12916d9b.ttf";